import React from 'react';
import './EmptyTeamChannel.scss';
import ball from "../../assets/imgs/ball.svg";
import screens from "../../assets/imgs/screens-mock.svg";

const EmptyTeamChannel = ({ isCenter })=> {
  return (
    <div className="no-data">
        <div className="no-data__content" style={{ left: !isCenter ? '37%' : '50%' }}>
          <div className="no-data__content__images">
              <img src={ball} className="no-data__content__images__ball" alt=''/>
              <img src={screens} className="no-data__content__images__screens" alt=''/>
          </div>
          <div className="no-data__content__title">
              <span className="no-data__content__title--white">WELCOME</span>
              <span className="no-data__content__title--green">TO MYPLAY!</span>
          </div>
          <span className="no-data__content__subtitle">There are still no videos on your Team Channel.</span>
          <span className="no-data__content__subtitle">{"We'll let you know when a new video is added!"}</span>
        </div>
    </div>
  );
};

export default EmptyTeamChannel;
